<template>
  <div class="inner-tab-wrapper mb-4">
    <b-overlay center :show="isLoading" rounded="sm">
      <div style="display: flex; flex-direction: column; gap: 1.25rem" v-if="!isLoading">
        <div class="form-card-wrapper">
          <b-card header-tag="header">
            <div
              slot="header"
              class="d-flex justify-content-between align-items-center"
            >
              <p class="mb-0 d-inline-block align-middle">
                <b>Dati Principali</b>
              </p>
              <b-btn
                variant="lisaweb"
                class="pl-4"
                size="sm"
                @click="migrate.click()"
                v-if="migrate.click"
              >
                {{ migrate.label }}
              </b-btn>
            </div>
            <div class="details-card custom-grid-wrapper">
              <div class="grid-item-label">
                <strong>Codice Produttore di Compagnia</strong>
              </div>
              <div class="grid-item-value">{{ dbRowData.map }}</div>
              <div class="grid-item-label"><strong>Compagnia</strong></div>
              <div class="grid-item-value">
                {{
                  dbRowData["insurer"] ? dbRowData.insurer.formatted_title : ""
                }}
              </div>
            </div>
          </b-card>
        </div>

        <div v-if="!dbRowData.mappable_id">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <b-card
                header-tag="header"
                class="mt-1"
              >
                <div
                  slot="header"
                  class="d-flex justify-content-between align-items-center"
                >
                  <p class="mb-0 d-inline-block align-middle">
                    <b>Mappatura Compagnie Coass - associa una Compagnia Coass</b>
                  </p>
                </div>
                <b-card-text>
                  <div class="form-group col-md-8">
                    <base-select
                      name="insurer_participants"
                      vid="insurer_participants"
                      label="Compagnie Coass"
                      v-model="form.mappable_id"
                      :options="opt_insurer_participant"
                      :rules="{ required: true }"
                    />
                  </div>
                </b-card-text>
              </b-card>
              <div class="py-2 mb-4">
                <b-button
                  @click="handleSubmit(onUpdate)"
                  type="button"
                  :disabled="invalid"
                  variant="lisaweb"
                  size="sm"
                >
                  Associa
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          <div class="form-card-wrapper">
            <b-card header-tag="header">
              <div
                slot="header"
                class="d-flex justify-content-between align-items-center"
              >
                <p class="mb-0 d-inline-block align-middle">
                  <b>Compagnia Coass</b>
                </p>
              </div>
              <div class="details-card custom-grid-wrapper">
                <div class="grid-item-label"><strong>Compagnie Coass</strong></div>
                <div class="grid-item-value">
                  {{ getInsurerParticipant(dbRowData) }}
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>

      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import ShowMixin from "@/mixins/ShowMixin";
import FormMixin from "@/mixins/FormMixin";
import BaseSelect from "@/components/form/BaseSelect";
import {RepositoryFactory} from "@/repositories/RepositoryFactory";

export default {
  name: "General",
  mixins: [FormMixin, ShowMixin],
  props: {
    resourceId: Number,
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    BaseSelect,
  },
  data() {
    return {
      repository: "import_map",
      isLoading: false,
      opt_insurer_participant: [],
      form: {
        mappable_id: null,
        import_map: {
          insurer_id: null,
          insurer_participant: {},
          map: null,
        },
      },
    };
  },
  methods: {
    onUpdate() {
      this.isLoading = true;
      this.setMandatoryField();
      this.update(this.repository, this.resourceId)
        .then(() => {
          this.$emit("fetch");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
    getInsurerParticipant(insurer_participant) {
      return `${
        insurer_participant?.mappable?.code
          ? insurer_participant.mappable.code
          : ""
      }-
      ${
        insurer_participant?.mappable?.formatted_title
          ? insurer_participant.mappable.formatted_title
          : ""
      }`;
    },
    setMandatoryField() {
      this.form[this.repository].insurer_id = this.dbRowData.insurer_id;
      this.form[this.repository].map = this.dbRowData.map;
      this.form[this.repository].insurer_participant = {
        [this.form.mappable_id]: {},
      };
    },
  },
  mounted() {
    this.isLoading = true;
    const Repo = RepositoryFactory.get("insurer_participant");
    Repo.index("perPage=0")
      .then((response) => {
        const data = response.data.data;
        this.opt_insurer_participant = data.map((e) => {
          return {
            value: e.id,
            text: `${e.code} - ${e.title}`,
            code: `${e.code}`,
          };
        });
        this.isLoading = false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({preset: "error", text: errMsg});
        this.isLoading = false;
      });
  },
};
</script>
